<template>
  <v-form ref="form">
    <v-row class="tableViewerContainer">
      <v-col cols="12" class="mb-4">
        <QuotationTableCostsViewerAgricola
          :form="form"
          :formProduct="formProduct"
          :formCost="formCost"
          :formInsured="formInsured"
          :formRisk="formRisk"
          :readonly-form="form"
          @submit="submit"
          v-model="formCost"
          v-if="modality == 'agricola'"
        />
        <QuotationTableCostsViewerCafezal
          :form="form"
          :formProduct="formProduct"
          :formCost="formCost"
          :formInsured="formInsured"
          :formRisk="formRisk"
          :readonly-form="form"
          @submit="submit"
          v-model="formCost"
          v-if="modality == 'cafezal'"
        />
      </v-col>
    </v-row>
    <BaseFooter v-if="currentQuotation.cancelada_em == null" class="no-print">
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pr-0 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotation"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import {
  asNumberString,
  formatExpirationDate,
  formatDDMMYYYYToIsoDate
} from "@/utils/formats.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { maskDate } from "@/utils/masks.js";
import { dateTermValid, requiredInput } from "@/utils/rules.js";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import QuotationTableCostsViewerAgricola from "../components_agro/QuotationTableCostsViewerAgricola";
import QuotationTableCostsViewerCafezal from "./QuotationTableCostsViewerCafezal.vue";
export default {
  components: {
    QuotationTableCostsViewerAgricola,
    QuotationTableCostsViewerCafezal
  },
  data() {
    return {
      formatExpirationDate,
      maskDate,
      timeout: null,
      dateTermValid,
      formatDDMMYYYYToIsoDate,
      initializeFilter: false,
      currentTab: 1,
      requiredInput,
      asNumberString,
      modalOpen: false
    };
  },
  props: {
    form: {
      type: Object
    },
    formInsured: {
      type: Object
    },
    formCost: {
      type: Object
    },
    formProduct: {
      type: Object
    },
    formRisk: {
      type: Object
    },
    modality: {
      type: String
    }
  },
  mixins: [LoadingRequest, CommonPayload],
  computed: {
    ...mapState("quotation", [
      "statusCurrentQuotation",
      "infoCostQuotation",
      "currentQuotationAgro",
      "listQuotationCostsAgro",
      "currentQuotation"
    ]),
    ...mapState(["nameOptionsDataTable", "filterDataTable"]),
  },
  methods: {
    ...mapActions("quotation", [
      "requestStatusCurrentQuotation",
      "requestListQuotationCostsAgro",
      "requestCurrentQuotation"
    ]),
    submit(value) {
      this.$emit("submit", value);
    },
    openModal(item) {
      this.form.selectedCost = item;
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
    },
    cancelQuotation() {
      this.$emit("cancel");
    }
  }
};
</script>
<style lang="sass">
.deadline-emission-type__
  &disclaimer
    border-radius: 4px
    background-color: #FFC55F
  &type-files
    border: 1px solid #D5D5E0 !important
    border-radius: 2px !important
    background-color: #FFFFFF !important
@media print
  .no-print
    display: none
.tableViewerContainer
  width: 95% !important
  margin: 0 auto !important
  padding-left: 30px
</style>
